const ordernarOpcoesPlanos = (primeiro, segundo) => {
  return primeiro.valorTarifa < segundo.valorTarifa
    ? 1
    : primeiro.valorTarifa > segundo.valorTarifa
    ? -1
    : 0;
};

const converterOndeUsarData = (array, state = false) => {
  const converertId = {
    CIDADE: 'est',
    ESTRADA: 'ped',
    TOTAL: 'ped-est',
    MANUAL: 'ped-est-manual',
  };
  const converterTitulo = {
    CIDADE: 'Estacionamentos',
    ESTRADA: 'Pedágios',
    TOTAL: 'Pedágios e Estacionamentos',
    MANUAL: 'Pedágios e Estacionamentos Manual',
  };

  const retornarCodigoPromocional = (obj, state) => {
    if (state) {
      return { codigoPromocional: obj.codPromocional };
    }
  };

  const subProduto = (obj) => {
    return obj.codSubProduto !== 1 ? obj.descSubProdCurta : 'MANUAL';
  };

  const novoObjetoFiltrado = array
    .filter((elemento) => elemento.descProduto !== 'POS PAGO')
    .map((obj) => {
      return {
        id: converertId[subProduto(obj)],
        planId: converertId[subProduto(obj)],
        titulo: converterTitulo[subProduto(obj)],
        texto: `R$ ${obj.valorTarifa}/mês`,
        valorTexto: `R$ ${obj.valorTarifa}/mês`,
        valor: `R$${obj.valorTarifa} após o período promocional`,
        textoDesconto: `${obj.numeroMesesBonificacao} mensalidades grátis`,
        temMensalidade: true,
        checkbox: false,
        subProdutoId: String(obj.codSubProduto).padStart(3, '0'),
        subProdutoDesc:
          obj.codSubProduto !== 1 ? obj.descSubProdCurta : 'MANUAL',
        idProduto: `${obj.idProduto}`,
        valorTarifa: obj.valorTarifa,
        tipoPlano: obj.descProduto.substr(0, 3),
        mesesBonificacao: obj.numeroMesesBonificacao,
        bonificacaoDesc: obj.descBonificacaoLonga,
        ...retornarCodigoPromocional(obj, state),
      };
    });

  const novoObjeto = array.map((obj) => {
    return {
      id: converertId[obj.descSubProdCurta],
      planId: converertId[obj.descSubProdCurta],
      titulo: converterTitulo[obj.descSubProdCurta],
      texto: `R$ ${obj.valorTarifa}/mês`,
      valorTexto: `R$ ${obj.valorTarifa}/mês`,
      valor: `R$${obj.valorTarifa} após o período promocional`,
      textoDesconto: `${obj.numeroMesesBonificacao} mensalidades grátis`,
      temMensalidade: true,
      checkbox: false,
      subProdutoId: String(obj.codSubProduto).padStart(3, '0'),
      subProdutoDesc: obj.descSubProdCurta,
      idProduto: `${obj.idProduto}`,
      valorTarifa: obj.valorTarifa,
      tipoPlano: obj.descProduto.substr(0, 3),
      mesesBonificacao: obj.numeroMesesBonificacao,
      bonificacaoDesc: obj.descBonificacaoLonga,
      ...retornarCodigoPromocional(obj, state),
    };
  });

  const opcoes = novoObjetoFiltrado.sort(ordernarOpcoesPlanos);
  const todos = novoObjeto.sort(ordernarOpcoesPlanos);

  return { opcoes, todos };
};

const adaptandoCodigosPromocionais = (array) => {
  const result = array.map((obj) => {
    if (obj.tipoPlano === 'POS') {
      return {
        ...obj,
        id: 'pos-pago',
        titulo: 'Pós pago',
        texto: 'Todo o seu gasto do mês é reunido em uma fatura',
        ehRecomendado: { ehRecomendado: false, label: '' },
        modal: 'modalPosPago',
      };
    }
    return {
      ...obj,
      id: 'recarga-automatica',
      titulo: 'Recarga automática',
      texto:
        'Você escolhe o valor da primeira recarga e as próximas são feitas automaticamente',
      ehRecomendado: { ehRecomendado: true, label: 'O JEITO MAIS PRÁTICO' },
      modal: 'modalRecarga',
    };
  });

  if (result[0].id === 'pos-pago') {
    return result.reverse();
  }

  return result;
};

export { converterOndeUsarData, adaptandoCodigosPromocionais };
